import { depascalize, decamelize as fastDecamelize } from 'fast-case';

export const decamelize = (obj: any, options?: { pascalCase?: boolean }) => {
  // deep is already handled by fast-case
  if (options?.pascalCase) {
    return depascalize(obj);
  }
  return fastDecamelize(obj);
};
